import { createElement, isValidElement } from 'react'
import PropTypes from 'propTypes'
import { fontSize } from '@offerzen/pinata-shame'

const AccessibleIcon = ({ icon, title, size = fontSize.medium, color, className, ariaHidden = false }) => {
  if (!icon) return null
  if (isValidElement(createElement(icon))) {
    return createElement(icon, {
      title: !ariaHidden && title,
      fontSize: size,
      color,
      className,
      'aria-hidden': (!title && 'true') || ariaHidden.toString(),
    })
  }
  return null
}

AccessibleIcon.propTypes = {
  icon: PropTypes.oneOfType([PropTypes.shape(), PropTypes.element]).isRequired,
  title: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  color: PropTypes.string,
  className: PropTypes.string,
  ariaHidden: PropTypes.bool,
}
export default AccessibleIcon
